import React, { useMemo } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { CardListItem } from 'features/my-gift-cards/components/CardListItem';
import { requestGetGiftCardsAction } from 'features/my-gift-cards/redux/action';
import { useSelector } from 'store';
import { Loaders } from 'shared';
import { useStyles } from './styles';
import * as _ from 'lodash';
import { AddGiftCard } from 'features/my-gift-cards/components/AddGiftCard';

interface CardsListProps {}

export const CardsList: React.FC<CardsListProps> = () => {
  const classes = useStyles();
  const { isLoading, cards } = useSelector(state => state.giftCards);
  const dispatch = useDispatch();

  if (!isLoading && !cards) {
    dispatch(requestGetGiftCardsAction({}));
  }

  const debounceGetGiftCards = useMemo(
    () =>
      _.debounce(
        async (brandName?: string) => dispatch(requestGetGiftCardsAction({ brand_name: brandName }, false)),
        300
      ),
    [dispatch]
  );

  if (isLoading) return <Loaders.Loader />;

  return (
    <>
      <AddGiftCard onChange={debounceGetGiftCards} />
      <Grid container spacing={9} className={classes.root}>
        {cards?.map(card => (
          <CardListItem key={card.id} {...card} />
        ))}
      </Grid>
    </>
  );
};
